import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ACTIONS } from '../../actions/actionTypes';

class RestartModalConfirmation extends Component {
    render () {
        const modalBackground = {
            position: 'absolute',
            display: 'block',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            zIndex: '100',
            overflow: 'auto',
            backgroundColor: 'rgba(0,0,0,0.6)'
        };

        /* Modal Content */
        const modalContent = {
            position: 'absolute',
            zIndex: '101',
            maxHeight: '80%',
            overflowY: 'scroll',
            transform: 'translate(-50%, -50%)',
            background: '#333',
            backgroundColor: '#fefefe',
            padding: '20px',
            border: '1px solid #888',
            borderRadius: 5,
            boxShadow: '5px 5px 3px #000000',
            width: '80%',
            flexWrap: 'wrap',
            display: 'flex',
            alignItems: 'center',
            top: '50%',
            left: '50%'

        };

        if (!this.props.modalOpen) {
            return null;
        }
        console.log('PROPS', this.props);
        return (
            <div style={modalBackground}>
                <div style={modalContent}>
                    <div style={{ 'wordWrap': 'break-word', width: '100%', marginBottom: 10 }}>
                        Atenção, deseja mesmo reiniciar o jogo? Seu progresso será apagado, mas suas medalhas serão mantidas
                    </div>
                    <div className='btn modal'
                        onClick={() => {
                            this.props.modalClose();
                        }}>
                        <h4>Fechar</h4>
                    </div>
                    <div className='btn modal'
                        onClick={() => {
                            this.restartGame();
                        }}>
                        <h4>Reiniciar</h4>
                    </div>
                </div>
            </div>
        );
    }

    restartGame () {
        this.props.restartGame();
    }
}

const mapStateToProps = ({restartModalConfirmationReducer}) => {
    const {modalOpen} = restartModalConfirmationReducer;
    return {modalOpen};
};

const mapActionsToProps = (dispatch) => ({
    restartGame: () => dispatch({
        type: ACTIONS.RESTART_GAME
    }),
    modalClose: () => dispatch({
        type: ACTIONS.CLOSE_PROFILE_MODAL
    })
});

export default connect(mapStateToProps, mapActionsToProps)(RestartModalConfirmation);



// WEBPACK FOOTER //
// ./src/views/components/restartModalConfirmation.js